import { FC } from "react";

import { IconView } from "@/components/_molecules/icon-picker/icon-view";
import { cn } from "@/lib/cn";

import { FocusArea } from "../models/focus-area-model";

import { FocusAreaViewEmpty } from "./focus-area-view-empty";

interface FocusAreaViewProps {
  focusArea: FocusArea | null;
  logoOnly?: boolean;
  canWrapLabel?: boolean;
  className?: string;
}

export const FocusAreaView: FC<FocusAreaViewProps> = ({ focusArea, ...props }) => {
  if (!focusArea) {
    return <FocusAreaViewEmpty {...props} />;
  }

  return (
    <div className={cn(["flex flex-row items-center gap-2", props.canWrapLabel && "min-w-0"])}>
      <IconView
        icon={focusArea.icon}
        iconType={focusArea.iconType}
        color={focusArea.color}
        className={cn(["h-5 w-5 shrink-0", props.className])}
      />
      {!props.logoOnly && (
        <div className={cn(["text-xs font-normal", props.canWrapLabel ? "break-words" : "whitespace-nowrap"])}>
          {focusArea.name}
        </div>
      )}
    </div>
  );
};
